import React from "react";
import ReactSelect from "react-select";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

export default function ExperienceType({ setExperience, filter, experience }) {
      const { state } = useAllFilterBaseContext();
  return (
    <div>
      <h6>{filter?.title}</h6>
      <ReactSelect
        options={filter.values.map((value) => ({
          value: value.id,
          label: value.title,
        }))}
        onChange={(selectedOption) => {
          setExperience(
            [selectedOption]?.map((value) => ({
              id: value.value,
              title: value.label,
            }))
          );
        }}
        value={
          Array.isArray(experience)
            ? experience?.map((sort) =>
                filter.values?.find((value) => value.id == sort.id)
                  ? {
                      value: sort.id,
                      label: filter.values.find((value) => value.id == sort.id)
                        ?.title,
                    }
                  : null
              )
            : null
        }
        placeholder="Select option"
      />
      {/* <div style={{ display: "flex", columnGap: "10px" }}>
        <input
          placeholder="Min"
          onChange={(e) =>
            setExperience(() => ({
              ...state.experience,
              min: e.target.value,
            }))
          }
        />
        <input
          placeholder="Max"
          onChange={(e) =>
            setExperience((prevData) => ({
              ...prevData,
              max: e.target.value,
            }))
          }
        />
      </div> */}
    </div>
  );
}
